// ECharts圖表組件國際化內容

export default {
  // 圖表默認配置
  defaultTitle: "Bar Chart 示例",
  defaultSeriesName: "數據量",
  unitPrefix: "(單位：",
  unitSuffix: ")",

  // 特定單位顯示
  unitTenThousandUSDT: "(單位：萬 USDT)",
  unitCount: "(單位：個)",

  // 圓餅圖相關
  monitorAddressRatio: "監控地址數佔比",
  ratioSeriesName: "佔比",

  // 柱狀圖相關
  inflowDataStatistics: "轉入數據統計",
  unitTransactions: "（單位：筆）",
  unitTenThousandUSDTWithBrackets: "（單位：萬 USDT）",
  totalInflowCount: "轉入總筆數",
  totalInflowAmount: "轉入總金額",

  // 折線圖相關
  maliciousAddressTransferTrend: "惡意地址轉賬趨勢圖",
  unitTenThousandYuan: "(萬元)",
  tenThousand: "萬",
  squarePaymentTransaction: "四方支付交易",
  gamblingTransaction: "涉賭交易",

  // 地圖相關
  caseCountLabel: "判例數量：",
  indictmentCountLabel: "起訴書數量：",
};
